import React from 'react'

export default function TableWrapper({ columns, data, ...tableProps }) {
  function getCell(row, col, i, j) {
    const value = typeof col.accessor === 'function' ? col.accessor(row) : row[col.accessor]
    const cellFn = typeof col.Cell === 'function' ? col.Cell : value => value
    const cellParams = { original: row, index: i, viewIndex: i, value, show: true, columnProps: col.props, classes: col.className, styles: col.styles }
    return <td key={col.id ?? col.accessor} className={col.className} style={col.styles}>{cellFn(cellParams)}</td>
  }

  return <table {...tableProps}>
    <thead>
      <tr>
        {columns.map(col => <th key={col.id ?? col.accessor} className={col.className} style={col.styles}>{col.Header}</th>)}
      </tr>
    </thead>
    <tbody>
      {data.map((row, i) => <tr key={i}>
        {columns.map((col, j) => getCell(row, col, i, j))}
      </tr>)}
    </tbody>
  </table>
}
